import API from "../../../Common/Network/API";
import store from "../../../Common/Store";
import { isLoaded, isLoading, roadblock, roadblockFilter } from "../actions";

export async function getRoadBlockUserStoriesToKanban(dispatch, getUser, moduleId, refresh) {
    if (refresh) { dispatch(isLoading()); }
    try {
      var response = await API.post(
        "get_user_stories.php",
        {
          crop: getUser.corp,
          action: "roadBlockToKanban",
          moduleId: moduleId,
          projectId: getUser.projectId,
          userType: getUser.role,
          empId: getUser.empId
        },
        {},
        false
      );
      // console.log(response)
      if (response.message === "No Data Available") {
        store.dispatch(roadblock([]));
        store.dispatch(roadblockFilter([]));
      } else {
        if (!response.data) {
          store.dispatch(roadblock([]));
          store.dispatch(roadblockFilter([]));
        } else {
          store.dispatch(roadblock(response.data));
          store.dispatch(roadblockFilter(response.data));
        }
      }
    } catch (error) {
    }
  
    dispatch(isLoaded());
  }
